<template lang="pug">
  #StoresManagerIndex
    h5.text-center.pt-2 店鋪管理
    b-row(
      no-gutters
      class="mb-3 px-2 button-row"
    )
      b-col(
        cols=4
      )
        b-button(
          block,
          :variant=" nowSelectType === 'index-sa' ? 'primary' : 'outline-primary' ",
          @click="changeTypeHandler('index-sa')"
        ) 店鋪BA
      b-col(
        cols=4
      )
        b-button(
          block,
          :variant=" nowSelectType === 'index-customer' ? 'primary' : 'outline-primary' ",
          @click="changeTypeHandler('index-customer')"
        ) 店鋪顧客
      b-col(
        cols=4
      )
        b-button(
          block,
          class="button-last rounded-0",
          :variant=" nowSelectType === 'index-reservation' ? 'primary' : 'outline-primary' ",
          @click="changeTypeHandler('index-reservation')"
        ) 店鋪預約
    b-card(
      bg-variant="gray",
      class="rounded-0 mb-2"
    )
      b-row(
        no-gutters
      )
        b-col(
          cols=6,
          class="pr-1"
        )
          multiselect(
            v-model="storesSelect.dealer",
            tag-placeholder="輸入搜尋經銷商",
            placeholder="請選擇經銷商",
            selectedLabel="已選擇",
            selectLabel="點擊新增經銷商",
            label="title",
            track-by="id"
            :options="storeDealer",
            :allow-empty="false"
            :close-on-select="true",
            :deselectLabel="''",
            noOptions="無經銷商",
            @select="selectDealerHandler"
          )
            template(slot="noOptions")
              strong 無經銷商
            template(slot="noResult")
              strong 無經銷商
        b-col(
          cols=6,
          class="pl-1"
        )
          multiselect(
            v-model="storesSelect.store",
            tag-placeholder="輸入搜尋店舖",
            placeholder="請選擇店舖",
            selectedLabel="已選擇",
            selectLabel="點擊新增店舖",
            label="title",
            track-by="id"
            :options="stores",
            :allow-empty="false",
            :close-on-select="true",
            :deselectLabel="''",
            noOptions="無店舖",
            @select="selectStoreHandler"
          )
            template(slot="noOptions")
              strong 無店舖
            template(slot="noResult")
              strong 無店舖
    .px-3
      .reservationInfo(
        v-show="nowSelectType === 'index-reservation'"
      )
        b-row(
          no-gutters
          class="mb-3"
        )
          b-col(
            cols=3,
            class="pr-1"
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === 'checking' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('checking')"
            ) 已預約
          b-col(
            cols=3,
            class="pr-1"
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === 'checked' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('checked')"
            ) 已確認
          b-col(
            cols=3,
            class="pr-1"
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === 'success' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('success')"
            ) 預約完成
          b-col(
            cols=3
          )
            b-button.h-100(
              block,
              :variant=" nowSelectStatus === 'expired' ? 'primary' : 'outline-primary' ",
              @click="changeStatusHandler('expired')"
            ) 已過期
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(store,index) in storeData",
        :key="index",
        v-if="storeData && storeData.length > 0"
      )
        //- 店鋪BA
        .typeOneShow(
          v-if="nowSelectType === 'index-sa'"
        )
          .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
            .col-4.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="store.picture_url",
                :style="{ 'width': '80px', 'height': '80px' }"
              )
            .col-6.px-1
              p.mb-0.font-weight-bold 姓名 {{ `${store.chinese_last_name} ${store.chinese_first_name}` }}
              p.mb-0 員工編號：{{ store.sa_code }}
            .col-2.pl-1
              .editBtn(
                @click="editSaHandler(store)"
              )
                b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button(
                  variant="primary"
                )
                  i.fas.fa-pencil-alt.fa-lg
          .baInfoRow.mb-3
            b-row
              b-col(
                cols=6
                class="d-flex align-items-center"
              )
                i.fas.fa-map-marker-alt.mr-2
                small 區域：{{ storeInfo.store_area }}
              b-col(
                cols=6
                class="d-flex align-items-center"
              )
                i.fas.fa-user.mr-2
                small 顧客數：{{ store.member_count }}位
        //- 店鋪顧客
        .typeTwoShow(
          v-if="nowSelectType === 'index-customer'"
        )
          .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
            .col-6.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="store.picture_url",
                :style="{ 'width': '80px', 'height': '80px' }"
              )
            .col-6.pl-1
              p.mb-0.font-weight-bold 暱稱名 {{ store.display_name }}
              p.mb-0 備註名 {{ store.customer_note_name }}
          .bindBaRow.mb-2.d-flex.align-items-center
            i.fas.fa-user.mr-2
            small 綁定BA：{{ store.sa_preferred_name }}
          .reserveAtRow.mb-2.d-flex.align-items-center
            i.far.fa-calendar-check.mr-2
            small 綁定日期：{{ store.latest_sa_binding_at ? store.latest_sa_binding_at : '-' }}
          .labelRow.d-flex.align-items-center.flex-wrap.mb-3
            i.fas.fa-tag.mr-2
            small 顧客標籤：
            small(
              v-if="store.tags && store.tags.length > 0"
            )
              b-badge.m-1.rounded-50.px-3.py-2(
                variant="primary",
                v-for="label in store.tags"
                :key="label.tag_id"
              ) {{ label.tag_name }}
            small(
              v-else
            ) 無
        //- 店鋪預約
        .typeThreeShow(
          v-if="nowSelectType === 'index-reservation'"
        )
          .reserveAtRow.mb-2.d-flex.align-items-center
            i.far.fa-calendar-check.mr-2
            small 顧客姓名：{{ `${store.customer_chinese_last_name} ${store.customer_chinese_first_name}` }}
          .reserveAtRow.mb-2.d-flex.align-items-center
            i.far.fa-calendar-check.mr-2
            small 預約時間：{{ store.reserve_date }} {{ store.start_time }} ~ {{ store.end_time }}
          .typeRow.mb-2.d-flex.align-items-center
            i.fas.fa-border-all.mr-2
            small 服務內容：{{ store.reserve_type_name }}
          .reserveBaRow.mb-2.d-flex.align-items-center
            i.fas.fa-user.mr-2
            small 預約BA：{{ store.sa_preferred_name }}
          .statusRow.mb-2.d-flex.align-items-center
            i.far.fa-check-circle.mr-2
            small 預約狀態：{{ store.status === 'checked' ? '已確認' : store.status === 'checking' ? '確認中' : store.status === 'success' ? '預約完成' : store.status === 'expired' ? '已過期' : '-' }}
        .labelTag(
          v-if="store.status === 'expired'",
          style="right: 0;bottom: 0;"
        )
          span.labelTag__text 已過期
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_STORES_MANAGER_EDIT_SA } from '@/router/sm/stores-manager';

export default {
  name: 'StoresManagerIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      nowSelectType: 'index-sa',
      nowSelectStatus: 'checking',
      infiniteId: +new Date(),
      storesSelect: {
        dealer: null,
        store: null
      }
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_stores_manager/resetHandler');
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('sm_stores_manager/getStoreDealerHandler')
      .then(() => {
        if (vm.storeDealer && vm.storeDealer.length > 0) {
          vm.storesSelect.dealer = vm.storeDealer[0];
          setTimeout(() => {
            vm.$store.dispatch('sm_stores_manager/getStoresHandler', {
              store_dealer_id: vm.storeDealer[0].id
            })
              .then(() => {
                if (vm.stores && vm.stores.length > 0) {
                  vm.storesSelect.store = vm.stores[0];
                  vm.infiniteId += 1;
                }
                vm.$swal.close();
              });
          }, 50);
        } else {
          vm.$swal.close();
        }
      });
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      let targetApi;
      if (!vm.storesSelect.store) {
        $state.complete();
        return;
      }
      switch (vm.nowSelectType) {
        case 'index-sa':
          targetApi = 'getIndexSaHandler';
          break;
        case 'index-customer':
          targetApi = 'getIndexCustomerHandler';
          break;
        case 'index-reservation':
          targetApi = 'getIndexReservationHandler';
          break;
        default:
          break;
      }
      if (!vm.storesSelect.store || !targetApi) return;
      vm.$store.dispatch(`sm_stores_manager/${targetApi}`, {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        store_id: vm.storesSelect.store.id,
        status: vm.nowSelectStatus
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeTypeHandler(type) {
      const vm = this;
      switch (type) {
        case 'index-sa':
          if (vm.nowSelectType === 'index-sa') return;
          vm.nowSelectType = 'index-sa';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'index-customer':
          if (vm.nowSelectType === 'index-customer') return;
          vm.nowSelectType = 'index-customer';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'index-reservation':
          if (vm.nowSelectType === 'index-reservation') return;
          vm.nowSelectType = 'index-reservation';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'checked':
          if (vm.nowSelectStatus === 'checked') return;
          vm.nowSelectStatus = 'checked';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checking':
          if (vm.nowSelectStatus === 'checking') return;
          vm.nowSelectStatus = 'checking';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelectStatus === 'success') return;
          vm.nowSelectStatus = 'success';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelectStatus === 'expired') return;
          vm.nowSelectStatus = 'expired';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    editSaHandler(sa_info) {
      const vm = this;
      vm.$router.push({
        name: SM_STORES_MANAGER_EDIT_SA,
        params: {
          sa_info,
          store_id: vm.storesSelect.store.id
        }
      });
    },
    // 更換經銷商
    selectDealerHandler(selectedOption) {
      const vm = this;
      if (!selectedOption) return;
      vm.$store.commit('sm_stores_manager/resetHandler');
      vm.storesSelect.store = null;

      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      vm.$store.dispatch('sm_stores_manager/getStoresHandler', {
        store_dealer_id: selectedOption.id
      })
        .then(() => {
          if (vm.stores && vm.stores.length > 0) {
            vm.storesSelect.store = vm.stores[0];
            vm.$store.commit('sm_stores_manager/resetHandler');
            vm.infiniteId += 1;
          }
          vm.$swal.close();
        });
    },
    // 更換店家
    selectStoreHandler(selectedOption) {
      const vm = this;
      if (!selectedOption) return;
      vm.$store.commit('sm_stores_manager/resetHandler');
      vm.infiniteId += 1;
    }
  },
  computed: {
    ...mapState({
      storeData: (state) => state.sm_stores_manager.storeData,
      storeDealer: (state) => state.sm_stores_manager.storeDealer,
      stores: (state) => state.sm_stores_manager.stores,
      storeInfo: (state) => state.sm_stores_manager.storeInfo,
      pagination: (state) => state.sm_stores_manager.pagination
    })
  }
};
</script>

<style lang="scss" scoped>
.multiselect__placeholder {
  margin-bottom: 8px;
}
</style>
